import { render, staticRenderFns } from "./PatentPending.vue?vue&type=template&id=4ba32366&"
import script from "./PatentPending.vue?vue&type=script&lang=js&"
export * from "./PatentPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports